import { render } from "./CurrentAddressPage.vue?vue&type=template&id=6abd1bc7&scoped=true"
import script from "./CurrentAddressPage.vue?vue&type=script&lang=js"
export * from "./CurrentAddressPage.vue?vue&type=script&lang=js"

import "./CurrentAddressPage.vue?vue&type=style&index=0&id=6abd1bc7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6abd1bc7"]])

export default __exports__